module.exports = __webpack_public_path__ + "img/swim.4cbf0259.webp";